import React, { useState } from "react";
import Index from "../../Index";

export default function Sidebar({ drawerOpen, setDrawerOpen }) {
  const pathname = Index.useLocation();

  const [openCMS, setOpenCMS] = useState(false);

  const removeClass = () => {
    setDrawerOpen((e) => !e);
    document.body.classList[drawerOpen ? "add" : "remove"]("body-overflow");
    document
      .getElementById("admin-sidebar")
      .classList[drawerOpen ? "add" : "remove"]("active");
  };

  const handleCMS = () => {
    setOpenCMS(!openCMS);
  };

  return (
    <>
      <Index.Box className="admin-sidebar-main scrollbar" id={"admin-sidebar"}>
        <Index.Box className="admin-sidebar-inner-main">
          <Index.Link to="/admin/dashboard" className="redirect-home-link">
            <Index.Box className="admin-sidebar-logo-main admin-side-logo-text">
              <img
                src={Index.Png.fbcLogo}
                className="admin-sidebar-logo"
                alt="logo"
              />
              {/* <Index.Typography
                variant="span"
                component="span"
                class="logo-text"
              >
                Farmar Bright Coin
              </Index.Typography> */}
              <Index.Box className="cross-res">
                <Index.Button onClick={removeClass}>
                  {" "}
                  <img
                    src={Index.Png.cancel}
                    className="close-icon-modal"
                    alt="cross"
                  />
                </Index.Button>
              </Index.Box>
            </Index.Box>
          </Index.Link>
          <Index.Box className="admin-sidebar-list-main">
            <Index.List className="admin-sidebar-list">
              <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/dashboard"
                  className={
                    pathname?.pathname === "/admin/dashboard"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.dashboard}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  Dashboard
                </Index.Link>
              </Index.ListItem>
              <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/social-media-post-request"
                  className={
                    pathname?.pathname === "/admin/social-media-post-request"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.waitlistUserNew}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  Social Media Post Request
                </Index.Link>
              </Index.ListItem>
              <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/presale-round"
                  className={
                    pathname?.pathname === "/admin/presale-round"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.presaleNew}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  Presale Management
                </Index.Link>
              </Index.ListItem>

              <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/waitlist"
                  className={
                    pathname?.pathname === "/admin/waitlist"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.waitlistUserNew}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  User List
                </Index.Link>
              </Index.ListItem>

              <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/active-user-list"
                  className={
                    pathname?.pathname === "/admin/active-user-list"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.waitlistUserNew}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  Active User List
                </Index.Link>
              </Index.ListItem>

              <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/network-transfer-list"
                  className={
                    pathname?.pathname === "/admin/network-transfer-list"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.waitlistUserNew}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  Network Transfer
                </Index.Link>
              </Index.ListItem>

              <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/exchange-transfer-list"
                  className={
                    pathname?.pathname === "/admin/exchange-transfer-list"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.waitlistUserNew}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  Exchange Transfer
                </Index.Link>
              </Index.ListItem>

              <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/wallet"
                  className={
                    pathname?.pathname === "/admin/wallet"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.waitlistUserNew}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  Wallet
                </Index.Link>
              </Index.ListItem>

              {/* <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/user_detail"
                  className={
                    pathname?.pathname === "/admin/user_detail"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.waitlistUserNew}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  User Details
                </Index.Link>
              </Index.ListItem> */}

              {/* <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/main-referral-list"
                  className={
                    pathname?.pathname === "/admin/main-referral-list"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.waitlistUserNew}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  Main Referral List
                </Index.Link>
              </Index.ListItem> */}

              <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/withdraw-list"
                  className={
                    pathname?.pathname === "/admin/withdraw-list"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.waitlistUserNew}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  Withdraw Request List
                </Index.Link>
              </Index.ListItem>

              <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/kyc-list"
                  className={
                    pathname?.pathname === "/admin/kyc-list"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.waitlistUserNew}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  KYC List
                </Index.Link>
              </Index.ListItem>

              <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/transaction"
                  className={
                    pathname?.pathname === "/admin/transaction"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.waitlistUserNew}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  Transaction List
                </Index.Link>
              </Index.ListItem>


              <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/exchange-deposit"
                  className={
                    pathname?.pathname === "/admin/exchange-deposit"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.waitlistUserNew}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  Exchange Deposit
                </Index.Link>
              </Index.ListItem>
              {/* <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/token-details"
                  className={
                    pathname?.pathname === "/admin/token-details"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.waitlistUserNew}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  Token Details
                </Index.Link>
              </Index.ListItem> */}
              {/* <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/kycDetail"
                  className={
                    pathname?.pathname === "/admin/kycDetail"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.waitlistadmin}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  KYC List
                </Index.Link>
              </Index.ListItem> */}

              {/* <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/stack"
                  className={
                    pathname?.pathname === "/admin/stack"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.waitlistadmin}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  Stake
                </Index.Link>
              </Index.ListItem> */}


            


              <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/setting"
                  className={
                    pathname?.pathname === "/admin/setting"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.settingNew}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  Setting
                </Index.Link>
              </Index.ListItem>

              <Index.ListItem className="admin-sidebar-listitem">
                <Index.Link
                  to="/admin/trade-summery"
                  className={
                    pathname?.pathname === "/admin/trade-summery"
                      ? "admin-sidebar-link active"
                      : "dashboard-header"
                  }
                  onClick={() => {
                    window.innerWidth <= 768 && removeClass();
                  }}
                >
                  <Index.Box className="admin-sidebar-icons">
                    <img
                      src={Index.Svg.settingNew}
                      className="admin-sidebar-icon"
                    />
                  </Index.Box>
                  Trade Summary
                </Index.Link>
              </Index.ListItem>

              {/* <Index.ListItem
                className="admin-sidebar-listitem admin-submenu-listitem-main"
                onClick={handleCMS}
              >
                <Index.Link className="admin-sidebar-link">
                  <Index.Box className="align-center">
                    <img
                      src={Index.Svg.cmsNew}
                      alt="sidebar icon"
                      className="admin-sidebar-icons"
                    />
                    <Index.Typography variant="span" component="span">
                      CMS
                    </Index.Typography>
                  </Index.Box>

                  {openCMS ? (
                    <Index.ExpandMore className="expandmore-icon" />
                  ) : (
                    <Index.ExpandLess className="expandless-icon" />
                  )}
                  <Index.Box className="submenu-main">
                    <Index.Collapse
                      in={openCMS}
                      timeout="auto"
                      unmountOnExit
                      className="submenu-collapse"
                    >
                      <Index.List
                        component="div"
                        disablePadding
                        className="admin-sidebar-submenulist"
                      >
                        <Index.ListItem className="admin-sidebar-listitem">
                          <Index.Link
                            to="/admin/cms/privacy-policy"
                            className={`${
                              pathname.pathname == "/admin/cms/privacy-policy"
                                ? "admin-sidebar-link active"
                                : "admin-sidebar-link "
                            }`}
                            onClick={() => {
                              window.innerWidth <= 768 && removeClass();
                            }}
                          >
                            Privacy Policy
                          </Index.Link>
                        </Index.ListItem>

                        <Index.ListItem className="admin-sidebar-listitem">
                          <Index.Link
                            to="/admin/cms/terms-and-condition"
                            className={`${
                              pathname.pathname ==
                              "/admin/cms/terms-and-condition"
                                ? "admin-sidebar-link active"
                                : "admin-sidebar-link "
                            }`}
                            onClick={() => {
                              window.innerWidth <= 768 && removeClass();
                            }}
                          >
                            Terms and Condition
                          </Index.Link>
                        </Index.ListItem>
                      </Index.List>
                    </Index.Collapse>
                  </Index.Box>
                </Index.Link>
              </Index.ListItem> */}
            </Index.List>
          </Index.Box>
        </Index.Box>
      </Index.Box>
    </>
  );
}
